import { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const answersSectionSx: SxProps<Theme> = {};

export const answerCardHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 1,
  mb: 1.5,
};

export const answerDetailRowSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.25,
  mb: 1,
  '&:last-child': {
    mb: 0,
  },
};

export const numericDetailsGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 1.5,
  '& > *': {
    mb: 0,
  },
};

export const answerDetailLabelSx: SxProps<Theme> = {
  color: 'text.secondary',
};

export const answerOptionsListSx: SxProps<Theme> = {
  pl: 2,
  m: 0,
};

/** Empty question label in answer preview — field content typography + muted italic. */
export const questionTextEmptySx: SxProps<Theme> = {
  fontSize: '0.875rem',
  fontWeight: 400,
  color: 'text.secondary',
  lineHeight: 1.5,
  fontStyle: 'italic',
};

export const requiredChipSx: SxProps<Theme> = {
  fontSize: '0.75rem',
  height: 24,
  fontWeight: 500,
  borderRadius: 1,
  bgcolor: Color.solidGray,
  color: 'text.secondary',
};
